/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useRef, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Input, Button, Spin, Row } from 'antd';
import CryptoHelper from 'utils/cryptHelper';
import { CompanyLogo } from 'images';
import { omit } from 'utils/user';
import auth from 'services/login/auth';
import { login, encryptJSON } from 'services/login/login';
import { LOGGEDIN_USER_DATA, ACCESS_MATRIX } from 'global_config/constant-global';
import URI from 'global_config/uri';
import { RegexInput } from 'shared_components/pattern_input';
import Message from 'shared_components/message';
import FIELD_RULES from './constants';
import { UserAccessContext } from 'context/userAccess';

import './login.css';

export default function Login() {
	const formRef = useRef();
	const history = useHistory();
	const { defineUserAccess } = useContext(UserAccessContext);
	const [loading, setLoading] = useState(false);

	async function handleSubmit() {
	// Using CryptoHelper for encryption
	 	// @ts-ignore
	 	const { getFieldsValue } = formRef.current;
		const { username, password } = getFieldsValue();
		let isAuthorized = true;

	 	try {
			setLoading(true);
			const response = await login(username, password);
			const loggedinUserData = {
				// ...omit(response.data, ['accessRights']),
				...response.data,
				secret: CryptoHelper.encryptString(password)
			};

			// // @ts-ignore
			const { accessRights } = response.data;
			if(response.data.title === 'not authorized'){
				isAuthorized = false;
			}
			
			defineUserAccess({ accessMatrix: accessRights });

			console.log('accessRights =>', accessRights);

			// const directEncryptAccessRights = CryptoHelper.encryptJSON(accessRights);

			// const jsonAccessRights = JSON.stringify(accessRights);
			// const encryptedJsonAccessRights = crypt.encrypt(jsonAccessRights);
			// console.log('directEncryptAccessRights =>', directEncryptAccessRights);
			// console.log('jsonAccessRights =>', jsonAccessRights);
			// console.log('encryptedJsonAccessRights =>', encryptedJsonAccessRights);

			sessionStorage.setItem(LOGGEDIN_USER_DATA, JSON.stringify(loggedinUserData));
			// Persist as encrypted JSON string using shared helper
			sessionStorage.setItem(ACCESS_MATRIX, encryptJSON(accessRights));

	 		Message.success({ message: 'You are now successfully logged in!' });

	 		auth.authenticate();
	 		// @ts-ignore
	 		redirectPage();
	 	}
	 	catch(error) {
			
			if(isAuthorized !== false)
			// if(error.response && error.response.status === 401)
	 			Message.error({message: 'Incorrect Username/Password'});
	 		else				
	 			Message.error({message: 'Something went wrong'});
	 	}
	 	finally {
	 		setLoading(false);
	 	}
	}

	function redirectPage() {
		// @ts-ignore
		const { getFieldsValue } = formRef.current;
	   	const { username, password } = getFieldsValue();

		if(username.toUpperCase() !== password.toUpperCase()){
			// Redirect to current session module or to dashboard module
			let selectedLink = URI.home.link;
   
			Object.keys(URI).forEach(k => {
				if(URI[k].key.toString() === sessionStorage.SELECTED_SIDER_KEY)
					selectedLink = URI[k].link;
			});

			history.push(selectedLink);
		}else{
			history.push('/change_password')
		}

		// history.push(selectedLink);
		// window.location.reload();		
	}

	return (
		<Spin spinning={loading}>
			<div>
				<div className="login-form">
					<div style={{ textAlign: 'center' }}>
						<img src={CompanyLogo} alt="logo" className="login-logo-image" />
					</div>
					<Form
						 onFinish={handleSubmit}
						ref={formRef}
						layout="vertical"
					>
						<Form.Item
							name="username"
							label="Username"
							className="login-input font12"
							rules={FIELD_RULES.Username}
							validateTrigger={'onBlur'}
						>
							<RegexInput maxLength={20} regex={/^[ A-Za-z0-9_@./-]*$/} />
						</Form.Item>						
						<Form.Item 
							name="password" 
							label="Password" 
							rules={FIELD_RULES.password}
							validateTrigger={'onBlur'}>
							<Input.Password type="password" maxLength={20} autoComplete='on' />
						</Form.Item>
						<Form.Item style={{ marginBottom: 0 }}>
							<Button
								style={{marginTop: 20}}
								type="primary"
								//  onClick={() => navigate.push('/home')}
								// onClick={() =>{window.location.href="https:www.myherohub.com/dev_site/grp/dev/home"}}
								//  onClick={() =>{window.location.href="home"}}
								htmlType="submit" className="login-form-button" block
							>
								LOG IN
							</Button>
						</Form.Item>
						<br></br>
						<a className="anchor-forgot-pass">Forgot password?</a>
					</Form>
				</div>
			</div>
		</Spin>
	);
}

// export default Login;
